// extracted by mini-css-extract-plugin
export var btn = "SearchResultsSection-module--btn--cfb1f";
export var buttonTag = "SearchResultsSection-module--buttonTag--c73eb";
export var contart = "SearchResultsSection-module--contart--4a178";
export var content = "SearchResultsSection-module--content--63fbe";
export var dialog = "SearchResultsSection-module--dialog--ff40b";
export var dialogContainer = "SearchResultsSection-module--dialogContainer--d1fbe";
export var filterIcon = "SearchResultsSection-module--filter-icon--af398";
export var footer = "SearchResultsSection-module--footer--3d949";
export var header = "SearchResultsSection-module--header--cc647";
export var hero = "SearchResultsSection-module--hero--88bd1";
export var jobSearch = "SearchResultsSection-module--jobSearch--9c98c";
export var jobSearchContainer = "SearchResultsSection-module--jobSearchContainer--8f7b3";
export var jobSearchMobile = "SearchResultsSection-module--jobSearchMobile--0e395";
export var localisation = "SearchResultsSection-module--localisation--787e2";
export var resulatButton = "SearchResultsSection-module--resulatButton--2dfe5";
export var seeMoreButton = "SearchResultsSection-module--seeMoreButton--909bd";
export var selectedFilter = "SearchResultsSection-module--selectedFilter--1e7c3";
export var selectedFilterContainer = "SearchResultsSection-module--selectedFilterContainer--4bd91";
export var tag = "SearchResultsSection-module--tag--6b8ee";
export var tags = "SearchResultsSection-module--tags--a869f";
export var tagsContainer = "SearchResultsSection-module--tagsContainer--ebdb5";
export var tagsMobile = "SearchResultsSection-module--tagsMobile--468c7";
export var tagsSwiper = "SearchResultsSection-module--tagsSwiper--07b83";